export interface AccredibleCountry extends AccrediblePlace {
  states?: AccrediblePlace[];
}

export interface AccrediblePlace {
  name: string;
  code: string;
}
